import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { WizardConfiguracaoComponent } from "../wizard-configuracao.component";
import { SimpleDatagridComponent } from "../../simple-datagrid/simple-datagrid.component";
import { DataGridColumns } from "src/app/interfaces/dagrid-columns";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-config-log',
    templateUrl: './config-log.component.html',
    styleUrls: ['./config-log.component.scss'],
    standalone: false
})
export class ConfigLogComponent implements OnInit {
  customFields: any;
  constructor(public uid: UserAuthenticationServices,@Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>) {}

  codecompany: number = 0;
  codecontract: number = 0;
  condition: string;
  getConditionLGTFunction = () => this.conditionLGT;  
  rowsCFG;
  conditionLGT= '0=0';
  criacaoConfiguaracao = WizardConfiguracaoComponent;
  @ViewChild('dataGridLgt') dataGridLgt:SimpleDatagridComponent;

  selectedRowCfg = (rowsSelect) => {
    this.rowsCFG = rowsSelect;  
    if(this.rowsCFG != null && this.rowsCFG.length  == 1) {
      this.conditionLGT = `idconf=${this.rowsCFG[0]['IDCONF']}`      
    }else{
      this.conditionLGT = `0=1`
    }
    this.loadLgt(); 
  }

  loadLgt(){
      this.dataGridLgt.apply();
  }

  ngOnInit(): void {
    
    this.condition = "0 = 0";
    this.conditionLGT = `idconf=${this.data['IDCONF']}`      
    // if (
    //   this.uid.user.companylist != null &&
    //   this.uid.user.companylist.length > 0
    // ) {
    //   //VERIFICAR COMO FAZER QUANDO TEM MAIS DE UMA EMPRESA
    //   //this.codecompany = Number(this.uid.user.companylist[0].codecompany);
    //   //this.codecontract = Number(this.uid.user.companylist[0].codecontract);
    //   this.condition += ` AND CODECOMPANY IN (${this.uid.getCompanies()})` 
    // }

    let custom:DataGridColumns = {
      columnDesc: 'Status de Processamento',
      columnName: 'STATUS',
      header: 'Status de Processamento',
      type:'INT',
      order:1,
      visible:false,
      width: 80,
      validationError:JSON.stringify({
          type:'select',
          options:[
            {
              view:'Processando',
              value:"RUNNING"
            },
            {
              view:'Aguardando',
              value:"TIME_WAITING"
            }
          ]
        })
      }

      //this.customFields.push(custom);
  }


  callbackFunction(dataRows:any[]){
      
    dataRows.forEach(row=>{
        row['STATUS']='RUNNING'
    })
  }
}
